import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { OrdenTrabajoDTO } from "app/main/apps/shared/interfaces/orden-trabajo.interface";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";

@Component({
    selector: "app-dialog-oocc",
    templateUrl: "./dialog-oocc.component.html",
    styleUrls: ["./dialog-oocc.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogOoccComponent implements OnInit {
    formOOCC: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<DialogOoccComponent>,

        private fb: FormBuilder,
        private validadorFormSrvc: ValidadoresFormularioService
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formOOCC = this.fb.group({
            nroOOCC: [null, { validators: [Validators.required,Validators.maxLength(20)] }],
            fecha: [null, { validators: [Validators.required] }],
            rutFacturar: [
                null,
                {
                    validators: [
                        Validators.required,
                        this.validadorFormSrvc.validadorRut(),
                    ],
                },
            ],
        });
    }

    get nroOOCC() {
        return this.formOOCC.get("nroOOCC");
    }

    get fecha() {
        return this.formOOCC.get("fecha");
    }

    get rutFacturar() {
        return this.formOOCC.get("rutFacturar");
    }
}
